import { getLocalizedString, isPresent } from '@grandvisionhq/utils';

const getOfferings = (offerings, locale)=>{
    if (!offerings) return undefined;
    return offerings.map((offering)=>{
        var ref, ref1, ref2, ref3;
        var _sku, _icon, _actions, _bundledProducts;
        return {
            title: getLocalizedString(offering.title, locale),
            subTitle: getLocalizedString(offering.subTitle, locale),
            originalPriceInformation: offering.price ? {
                // Map to a decimal for consistency with the other prices to allow calculations
                amount: ((ref = offering.price) === null || ref === void 0 ? void 0 : ref.value.centAmount) / 100,
                currencyCode: (ref1 = offering.price) === null || ref1 === void 0 ? void 0 : ref1.value.currencyCode
            } : undefined,
            discountedPriceInformation: ((ref2 = offering.price) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.discounted) === null || ref3 === void 0 ? void 0 : ref3.value) ? {
                // Map to a decimal for consistency with the other prices to allow calculations
                amount: offering.price.discounted.value.centAmount / 100,
                currencyCode: offering.price.discounted.value.currencyCode
            } : undefined,
            sku: (_sku = offering.sku) !== null && _sku !== void 0 ? _sku : undefined,
            icon: (_icon = offering.icon) !== null && _icon !== void 0 ? _icon : undefined,
            isInsuranceReimbursable: !!offering.isInsuranceReimbursable,
            bundleContentDescription: getLocalizedString(offering.bundleContentDescription, locale),
            actions: ((_actions = offering.actions) !== null && _actions !== void 0 ? _actions : []).filter(isPresent).map((action)=>({
                    action: action.action,
                    variantSku: action.variant
                })
            ),
            bundledProductSkus: (_bundledProducts = offering.bundledProducts) !== null && _bundledProducts !== void 0 ? _bundledProducts : []
        };
    });
};

export { getOfferings };
//# sourceMappingURL=get-offerings.js.map
